// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh4[data-v-77f290fa] {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 0.5rem;\n  line-height: 1.4;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
